import React from "react";
import { motion } from "framer-motion";
import "./RegistrationStepper.css";

const CheckIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"
    strokeLinecap="round" strokeLinejoin="round" width="13" height="13">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

export const REGISTRATION_FLOW_STEPS = [
  {
    id: "registration",
    title: "Registration",
    description: "Fill in your details",
    badgeColor: "#ef4444",
    badgeShadow: "rgba(239,68,68,0.45)",
  },
  {
    id: "mobile",
    title: "Mobile Verification",
    description: "Confirm your mobile OTP",
    badgeColor: "#f59e0b",
    badgeShadow: "rgba(245,158,11,0.45)",
  },
  {
    id: "success",
    title: "Successful",
    description: "You're ready!",
    badgeColor: "#22c55e",
    badgeShadow: "rgba(34,197,94,0.45)",
  },
];

const RegistrationStepper = ({
  steps = REGISTRATION_FLOW_STEPS,
  activeStep = 0,
}) => {
  return (
    <div className="rst-sidebar d-none d-md-block">
      <p className="rst-heading">3 Simple Steps to Unlock Full Access</p>
      <ul className="rst-list">
        {steps.map((step, index) => {
          const isActive = index === activeStep;
          const isDone = index < activeStep;

          return (
            <li
              key={step.id}
              className={`rst-item${isActive ? " rst-item--active" : ""}${isDone ? " rst-item--done" : ""}`}
            >
              <motion.div
                className="rst-inner"
                animate={{ x: isActive ? 0 : 0 }}
                initial={false}
              >
                {/* Colored traffic-signal badge */}
                <motion.div
                  className="rst-badge"
                  animate={{
                    backgroundColor: isDone ? step.badgeColor : isActive ? step.badgeColor : "rgba(255,255,255,0.15)",
                    boxShadow: isActive ? `0 0 0 3px rgba(255,255,255,0.2), 0 4px 12px ${step.badgeShadow}` : "none",
                    scale: isActive ? 1.1 : 1,
                  }}
                  transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
                  style={{ color: isActive || isDone ? "#fff" : "rgba(255,255,255,0.4)" }}
                >
                  {isDone ? <CheckIcon /> : <span>{index + 1}</span>}
                </motion.div>

                {/* Text */}
                <div className="rst-copy">
                  <motion.span
                    className="rst-title"
                    animate={{ color: isActive ? "#1e293b" : isDone ? "rgba(255,255,255,0.75)" : "rgba(255,255,255,0.4)" }}
                    transition={{ duration: 0.3 }}
                  >
                    {step.title}
                  </motion.span>
                  <motion.span
                    className="rst-desc"
                    animate={{ color: isActive ? "#64748b" : "rgba(255,255,255,0.3)" }}
                    transition={{ duration: 0.3 }}
                  >
                    {step.description}
                  </motion.span>
                </div>
              </motion.div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default RegistrationStepper;
